import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Forgot To Scan</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
